import { render } from "./FormPassword.vue?vue&type=template&id=3137328e"
import script from "./FormPassword.vue?vue&type=script&lang=js"
export * from "./FormPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Form/FormPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3137328e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3137328e', __exports__)) {
    console.log('reload')
    api.reload('3137328e', __exports__)
  }
  
  module.hot.accept("./FormPassword.vue?vue&type=template&id=3137328e", () => {
    console.log('re-render')
    api.rerender('3137328e', render)
  })

}


export default __exports__